module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d527a686da1975e039bf23e523bf1987.png";